import React, { useState } from "react";
import Logo from "../../assets/logos/logo1.png";
import LogoResponsive from "../../assets/logos/logo-responsive.png";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ClusterOutlined,
  SnippetsOutlined,
  UserOutlined,
  TeamOutlined,
  AuditOutlined,
  SettingOutlined,
  NotificationOutlined,
  FileProtectOutlined,
} from "@ant-design/icons";
import { Layout, Menu, Button, theme } from "antd";
import MenuButton from "../dropdown/Menu";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import cookie from "react-cookies";
import { parseJWT } from "../../utils/tokenDecode";

const { Header, Sider, Content } = Layout;

const Layout1 = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  // token for color
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  // Token
  const token = cookie.load("token");
  // function to get Tabs Props
  const getItem = (label, key, icon, children, theme) => {
    return {
      key,
      icon,
      children,
      label,
      theme,
    };
  };

  // handler to show active part
  const activeTabHandler = (actveRoute) => {
    switch (actveRoute) {
      // case "/":
      //   return "1";
      case "/":
        return "2";
      case "/add-admin":
        return "2";
      case "/edit-admin":
        return "2";
      case "/properties":
        return "3";
      case `/properties/${location?.pathname?.split("/")[2]}`:
        return "3";
      case "/properties-requests":
        return "3b";
      case "/tasks":
        return "4";
      case "/create-task":
        return "4";
      case `/edit-task/${location?.pathname?.split("/")[2]}`:
        return "4";
      case "/leads":
        return "5";
      case "/salary-details":
        return "6a";
      case "/add-salary":
        return "6a";
      case `/salary-details/${location?.pathname?.split("/")[2]}`:
        return "6a";
      case `/edit-salary/${location?.pathname?.split("/")[2]}`:
        return "6a";
      case "/add-attandance":
        return "6b";
      case "/bank":
        return "6c";
      case "/add-bank-details":
        return "6c";
      case `/bank-details/${location?.pathname?.split("/")[2]}`:
        return "6a";
      case `/edit-bank-details/${location?.pathname?.split("/")[2]}`:
      default:
        return "1";
    }
  };

  // handler to show active sub menu options
  const activeSubOptionHandler = (acitveRoute) => {
    switch (acitveRoute) {
      case "/properties":
        return "3";
      case `/properties/${location?.pathname?.split("/")[2]}`:
        return "3";
      case "/properties-requests":
        return "3b";
      case "/salary-details":
        return "6a";
      case "/add-salary":
        return "6a";
      case `/edit-salary/${location?.pathname?.split("/")[2]}`:
        return "6a";
      default:
        return "";
    }
  };

  const tabs = [
    {
      id: "2",
      img: <UserOutlined />, // icon name
      route: "/",
      title: "User",
      accessRole: ["admin"],
    },
    {
      id: "3",
      img: <TeamOutlined />, // icon name
      route: "/properties?page=1",
      title: "Properties",
      accessRole: ["admin"],
    },
    {
      id: "4",
      img: <SnippetsOutlined />, // icon name
      route: "/tasks",
      title: "Tasks",
      accessRole: ["admin"],
    },
    {
      id: "6",
      img: <AuditOutlined />, // icon name
      title: "HR",
      accessRole: ["admin"],
      children: [
        {
          id: "6a",
          route: "/salary-details?page=1",
          title: "Salary Details",
        },
        {
          id: "6c",
          route: "/bank?page=1",
          title: "Bank Details",
        },
      ],
    },
    {
      id: "7",
      img: <FileProtectOutlined />, // icon name
      route: "/",
      title: "Attandance",
      accessRole: ["admin"],
      children: [
        {
          id: "7a",
          route: "/",
          title: "Tasks",
        },
        {
          id: "7b",
          route: "/",
          title: "Completed Tasks",
        },
      ],
    },
    {
      id: "8",
      img: <ClusterOutlined />, // icon name
      route: "/",
      title: "Templates",
      accessRole: ["admin"],
      children: [
        {
          id: "8a",
          route: "/",
          title: "Agrements",
        },
        {
          id: "8b",
          route: "/",
          title: "Documents",
        },
        {
          id: "8c",
          route: "/",
          title: "Reports",
        },
        {
          id: "8d",
          route: "/",
          title: "Emails",
        },
      ],
    },
    {
      id: "9",
      img: <SettingOutlined />, // icon name
      route: "/",
      title: "Settings",
      accessRole: ["admin"],
    },
    {
      id: "9",
      img: <NotificationOutlined />, // icon name
      route: "/",
      title: "Notification",
      accessRole: ["admin"],
    },
  ];

  // handler for tabs which has sub options
  const childTabs = (tab) => {
    return getItem(
      <Link>{tab?.title}</Link>,
      tab?.id,
      tab.img,
      tab?.children?.map((child) => {
        return getItem(
          <Link to={child?.route}>{child?.title}</Link>,
          child?.id
        );
      })
    );
  };

  // userTabsPermissions
  const userTabsPermissions = () => {
    const user = parseJWT(token);
    const selectedTabs = tabs?.map((tab) => {
      if (tab.accessRole?.includes(user?.role)) {
        return tab?.children?.length > 0
          ? childTabs(tab)
          : getItem(<Link to={tab?.route}>{tab?.title}</Link>, tab.id, tab.img);
      }
      return tab.accessRole?.includes(user?.role);
    });
    return selectedTabs;
  };

  // sidenav items
  // const items = [
  //   getItem(<Link to="/">Dashboard</Link>, "1", <AppstoreOutlined />),
  //   getItem(<Link to="/admins">Admin</Link>, "2", <UserOutlined />),
  //   getItem(<Link>Properties</Link>, "3", <TeamOutlined />, [
  //     getItem(<Link to="/properties?page=1">Properties</Link>, "3a"),
  //     getItem(
  //       <Link to="/properties-requests">Requested Properties</Link>,
  //       "3b"
  //     ),
  //   ]),
  //   getItem(<Link to="/tasks">Tasks</Link>, "4", <DollarOutlined />),
  //   getItem(<Link to="/leads">Leads</Link>, "5", <DollarOutlined />),
  //   getItem(<Link>Account</Link>, "6", <FileProtectOutlined />, [
  //     getItem(<Link to="/accounts?page=1">All Account</Link>, "6a"),
  //     getItem(<Link to="/add-account">Add Account</Link>, "6b"),
  //   ]),
  //   // refectoring
  //   // getItem(<Link>Subscription</Link>, "sub1", <ProfileOutlined />, [
  //   //   getItem(<Link to="/subscribed-users">Subscribed Users</Link>, "5"),
  //   //   getItem(<Link to="/subscriptions">Subscription Plans</Link>, "6"),
  //   // ]),
  //   // getItem(<Link to="/faq">FAQ</Link>, "11", <QuestionCircleOutlined />),
  //   // getItem(
  //   //   <Link to="/information">Information</Link>,
  //   //   "12",
  //   //   <ContainerOutlined />
  //   // ),
  //   // getItem(<Link to="/calendar">Calendar</Link>, "13", <CalendarOutlined />),
  //   // getItem(<Link to="/contact">Contact Us</Link>, "14", <FileTextOutlined />),
  //   // getItem(
  //   //   <Link to="/reports">Reports</Link>,
  //   //   "15",
  //   //   <ReconciliationOutlined />
  //   // ),
  //   // getItem(<Link to="/login">Logout</Link>, "16", <LogoutOutlined />),
  // ];
  return (
    <Layout style={{ height: "100vh" }}>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="demo-logo-vertical" />
        <div className="sidebar_logo">
          {!collapsed ? (
            <React.Fragment>
              <img src={Logo} alt="" />
            </React.Fragment>
          ) : (
            <img src={LogoResponsive} alt="" />
          )}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[activeTabHandler(location?.pathname)]}
          defaultOpenKeys={[activeSubOptionHandler(location?.pathname)]}
          items={userTabsPermissions()}
          selectedKeys={[activeTabHandler(location?.pathname)]}
        />
      </Sider>
      <Layout>
        <Header
          style={{
            padding: 0,
            background: colorBgContainer,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "20px",
              width: 64,
              height: 64,
            }}
          />
          <MenuButton />
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            overflowY: "scroll",
            background: colorBgContainer,
          }}
        >
          {props.children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default Layout1;
